<template>
  <div>
    <div class="section-title">
      Paso 1. Tu inversión
    </div>
    <div class="section-summary">
      Ya cada vez éstas más cerca de convertirte en un inversionista de tu restaurante favorito, aquí puedes observar el cálculo del retorno al terminar el periodo de tiempo. Recuerda que el rendimiento esperado esta basado únicamente en proyecciones financieras y no están de ninguna manera garantizado o asegurado.
    </div>
    <div class="section-content">
      <div class="section-column">
        <label class="input-label">
          Proyecto
          <input class="input" type="text" :value="currentProject.name" disabled />
        </label>
        <label class="input-label">
          Duración
          <input class="input" type="text" value="5 años" disabled />
        </label>
        <label class="input-label">
          Cantidad a invertir
          <input class="input" v-model="investment"  disabled />
        </label>
      </div>
      <div class="section-column">
        <div class="projections">
          <div class="projections-title">
            Tu inversión al cabo de 5 años
          </div>
          <div class="projection-subtitle">Optimista</div>
          <div class="projection-value">${{ stylizeEntry(optimisticForecast) }}</div>
          <div class="projection-subtitle">Conservador</div>
          <div class="projection-value">${{ stylizeEntry(conservativeForecast) }}</div>
          <div class="projection-subtitle">Pesimista</div>
          <div class="projection-value">${{ stylizeEntry(pessimisticForecast) }}</div>
        </div>
      </div>
    </div>
    <div class="section-button">
      <div class="button" @click="nextButton">Siguiente</div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import formatMixin from '@/mixins/formatMixin';
import axios from 'axios';

const { mapState, mapMutations } = createNamespacedHelpers('investment');

export default {
  mixins: [formatMixin],
  computed: {
    optimisticForecast() {
      if (this.totalInvestment) {
        return (this.totalInvestment * ((1 + (this.currentProject.optimisticIrr / 100)) ** 5)).toFixed(2);
      }
      return 0;
    },
    pessimisticForecast() {
      if (this.totalInvestment) {
        return (this.totalInvestment * ((1 + (this.currentProject.pessimistIrr / 100)) ** 5)).toFixed(2);
      }
      return 0;
    },
    conservativeForecast() {
      if (this.totalInvestment) {
        return (this.totalInvestment * ((1 + (this.currentProject.conservativeIrr / 100)) ** 5)).toFixed(2);
      }
      return 0;
    },
    investment: {
      get() {
        return this.formatMoney(this.totalInvestment);
      },
      set(value) {
        this.setInvestment(value);
      },
    },
    ...mapState([
      'currentProject',
      'totalInvestment',
    ]),
  },
  methods: {
    stylizeEntry(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nextButton() {
      const url = `${process.env.VUE_APP_SERVER_URL}/user/pre-investments`;
      const data = {
        projectId: this.currentProject.id,
        investment: this.totalInvestment,
      };
      axios.post(url, data).then(() => {
        this.$emit('next');
      });
    },
    ...mapMutations([
      'setInvestment',
    ]),
  },
};
</script>

<style lang="scss" scoped>
.projections {
  display: flex;
  flex-direction: column;
}
.projections-title {
  font-weight: 500;
  text-align: center;
  margin-top: 40px;
}
.projection-subtitle {
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  margin-top: 18px;
}
.projection-value {
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  margin-top: 10px;
}
</style>
